module.exports = __webpack_public_path__ + "img/brand_88.50e16c81.png";